
import { DecimalPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface SurgeryParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Surgery {
  Id?: any;
  surgeryName: string;
  icdCode:string;
  cptCode:string;
  price:any;
  snomedCode:number;
  categoryId: number;
  subCategoryId: number;
  tenantId?: string;
  branchId?: string;
    parameters?: SurgeryParameter[];
    links?: any;
}

export abstract class SurgeryData {
 
  abstract list(url: string): Observable<Surgery[]>;
  abstract create(url: string,data: Surgery): Observable<any>;
  abstract update(url: string,data: Surgery): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
